export default {
  header: 'Your Financial Profile'
};
